import React from "react";
import ContainerComponent from "../../../../components/Container/ContainerComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";
import GridComponent from "../../../../components/Grid/GridComponent";
import { ItemDestaqueMidia, ItemMaisPedido } from "../CatalogoPage";
import { formatNumberToDinheiro } from "../../../../utils/dinheiro";
import CardComponent from "../../../../components/Card/CardComponent";

interface MaisPedidosProps {
    itensMaisPedidos: ItemMaisPedido[];
}

const MaisPedidosComponent = (props: MaisPedidosProps) => {
    return <ContainerComponent
        component="section"
        sx={{ mt: 5, pb: 6 }}
    >
        <TypographyComponent
            variant="h6" fontWeight="bold" mb={2}
            sx={{
                fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 600,       // SemiBold
                fontSize: '1.5rem',    // 24px / 16px = 1.5rem
                lineHeight: 1.333,     // 32px (token 'm') / 24px
                letterSpacing: '0em',
                display: 'inline-flex',
                alignItems: 'center',
                textTransform: "uppercase"
            }}
        >
            Os mais pedidos
        </TypographyComponent>

        <BoxComponent
            component="div"
            sx={{
            }}
        >
            <GridComponent
                component="article"
                sx={{
                    display: "grid"
                }}
            >
                {Array.isArray(props.itensMaisPedidos) && props.itensMaisPedidos.map((item: ItemMaisPedido, index: number) => {
                    const isItemAnterior = item.precoAnterior != null;
                    const midiaAtiva = item.midias?.find(m => m.ativo);

                    // FLAGS
                    var flagBackgroundColor = "";
                    var flagColor = "";
                    if (item.flag === "EDIÇÃO LIMITADA") {
                        flagBackgroundColor = "#FCE7F3B2";
                        flagColor = "#DB2777";
                    }
                    else if (item.flag === "NOVIDADE") {
                        flagBackgroundColor = "#D1FAE5B2";
                        flagColor = "#059669";
                    }
                    else if (item.flag === "MAIS PEDIDO") {
                        flagBackgroundColor = "#FEF3C7B2";
                        flagColor = "#D97706";
                    }

                    return <CardComponent
                        component="div"
                        key={`destaque-${index}`}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            boxSizing: 'border-box',
                            transform: 'rotate(0deg)',
                            overflow: 'hidden',
                            width: {
                                xs: "100%",
                                sm: 375,
                                lg: 442
                            },
                            height: {
                                xs: "auto",
                                lg: 207.46
                            },
                            minHeight: 112,
                            backgroundColor: '#FFFFFF',
                            opacity: 1,
                            borderRadius: '8px',
                            border: '1px solid #0000001F',
                            borderTop: '1px solid #0000001F',
                            padding: 1.6,
                            gap: 2
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1
                            }}
                        >
                            <BoxComponent
                                component="header"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.8,
                                    height: "80%"
                                }}
                            >
                                {item.flag && (
                                    <TypographyComponent
                                        variant="body2" fontWeight=""
                                        sx={{
                                            fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                                            fontWeight: 500,
                                            fontSize: '0.75rem',
                                            lineHeight: 1.333,
                                            letterSpacing: '0em',
                                            backgroundColor: flagBackgroundColor,
                                            color: flagColor,
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: "6px",
                                            px: "10px",
                                            py: "4px",
                                            width: 'fit-content'
                                        }}
                                    >
                                        {item.flag}
                                    </TypographyComponent>
                                )}
                                <TypographyComponent
                                    variant="h3" fontWeight="bold"
                                    sx={{
                                        fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                                        fontSize: '1rem',      // 16px / 16px
                                        lineHeight: 1.5,       // 24px / 16px
                                        letterSpacing: '0em',
                                        color: '#374151',
                                        display: 'inline-flex',
                                        alignItems: 'center',

                                    }}
                                >
                                    {item.titulo}
                                </TypographyComponent>
                                <TypographyComponent
                                    variant="body2" fontWeight=""
                                    sx={{
                                        fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                                        fontWeight: 300,        // Light
                                        fontSize: '0.875rem',  // 14px / 16px
                                        lineHeight: 1.428,     // 20px / 14px
                                        letterSpacing: '0em',
                                        color: '#6B7280',      // Cor Grey-46
                                        display: 'inline-flex',
                                        alignItems: 'center', 

                                        // PARA NAO TER OVERFLOW
                                        maxHeight: "45%",
                                        whiteSpace: "collapse",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {item.descricao}
                                </TypographyComponent>
                            </BoxComponent>
                            <BoxComponent
                                component="footer"
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 2,
                                    height: "20%"
                                }}
                            >
                                <TypographyComponent
                                    variant="body2" fontWeight="bold"
                                    sx={{
                                        fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                                        fontWeight: 400,        // Regular
                                        fontSize: '1rem',      // 16px / 16px
                                        lineHeight: 1.5,       // 24px / 16px
                                        letterSpacing: '0em',
                                        color: isItemAnterior ? '#10B981' : "#374151",
                                        display: 'inline-flex',
                                        alignItems: 'center',  // Para o vertical-align: middle
                                    }}
                                >
                                    {formatNumberToDinheiro(item.precoAtual)}
                                </TypographyComponent>

                                {item.precoAnterior && (
                                    <TypographyComponent
                                        variant="body2" fontWeight="bold"
                                        sx={{
                                            fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                                            fontWeight: 400,
                                            fontSize: '0.875rem',  // 14px / 16px
                                            lineHeight: 1.428,     // 20px / 14px
                                            letterSpacing: '0em',
                                            textDecoration: 'line-through',
                                            color: '#6B7280',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {formatNumberToDinheiro(item.precoAnterior)}
                                    </TypographyComponent>
                                )}
                            </BoxComponent>
                        </BoxComponent>
                        <BoxComponent component="div">
                            <BoxComponent component="img"
                                sx={{
                                    width: "128px",
                                    height: "128px",
                                    angle: "0 deg",
                                    opacity: 1,
                                    borderRadius: "8px"
                                }}
                                src={midiaAtiva?.caminho}
                                alt={`mais-pedido-${item.titulo}`}
                            />
                        </BoxComponent>
                    </CardComponent>
                })}
        </GridComponent>
    </BoxComponent>
    </ContainerComponent >
}

export default MaisPedidosComponent;